export default {"src":"/_next/static/media/pizza.0263a830.svg","height":681,"width":681,"blurWidth":0,"blurHeight":0};